<fd-message-strip class="info-strip" [dismissible]="false">
    <div class="strip-content">
        <fd-icon [glyph]="'message-information'"></fd-icon>
        <span class="view-info-details-inline">{{infoText}}</span>
        <span class="view-info-details link-color" href="#"
              (click)="onMoreDetailsClicked()">{{moreDetails}}</span>
    </div>
</fd-message-strip>